export default __webpack_public_path__ + "static/media/group2.58afb9f7.png";